export const ADD_ADDRESS = 'ADD_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const RESET_ADDRESS = 'RESET_ADDRESS';
export const GET_ADDRESS= 'GET_ADDRESS';